import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { catchError, from, of, Subscription, switchMap } from 'rxjs';
import { SnackBarService } from 'src/app/shared/services/snackbar.service';
import { InvoiceModel } from 'src/shared-app-portal/components/profile-payments/invoice-model';
import { BasePaymentsDirective } from 'src/shared-app-portal/directives/base-payments.directive';
import { PaymentService } from 'src/shared-app-portal/services/payment.service';

@Component({
  selector: 'app-portal-team-payments',
  templateUrl: './portal-team-payments.component.html',
  styleUrl: './portal-team-payments.component.scss',
  standalone: false
})
export class PortalTeamPaymentsComponent
  extends BasePaymentsDirective
  implements OnInit, OnDestroy
{
  private paramSub: Subscription;
  public loading: boolean = true;

  constructor(
    protected paymentService: PaymentService,
    protected snackBarService: SnackBarService,
    private route: ActivatedRoute,
    private router: Router
  ) {
    super(paymentService, snackBarService);
  }

  override async ngOnInit() {
    this.buildStatusFilters();
    this.paramSub = this.route.paramMap
      .pipe(
        switchMap((params) => {
          const teamId = params.get('id');
          if (!teamId) {
            this.router.navigate(['portal/not-found'], { skipLocationChange: true });
            return of(null);
          }
          this.loading = true;
          this.paymentService.initForPortalTeam(teamId);
          return from(this.paymentService.getInvoices()).pipe(catchError(() => of(null)));
        })
      )
      .subscribe((invoices: InvoiceModel[]) => {
        this.dataSource.setPayments(invoices);
        this.loading = false;
      });
  }

  ngOnDestroy(): void {
    this.paramSub?.unsubscribe();
  }
}
